export default __webpack_public_path__ + "static/media/failed.1ac7e8c1.gif";